import styled from "styled-components";

export const RewardDetailContainerStyled = styled.div`
  padding: 32px 20px 40px 20px;
  .reward_container_layout {
    .info_list_block {
      margin-bottom: 20px;
      .info_item {
        margin-bottom: 4px;
        display: flex;
        column-gap: 16px;
        &.mb_22 {
          margin-bottom: 22px;
        }
        .info_label {
          width: 130px;
          flex-basis: calc(50% - 8px);
          white-space: nowrap;
          color: ${({ theme }) => theme.COLORS.BLACK_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S14};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_REGULAR};
        }
        .info_value {
          flex-basis: calc(50% - 8px);
          color: ${({ theme }) => theme.COLORS.PURPLE_1};
          font-size: ${({ theme }) => theme.FONT.SIZE.S14};
          font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
          span {
            color: ${({ theme }) => theme.COLORS.PURPLE_1};
            font-size: ${({ theme }) => theme.FONT.SIZE.S16};
            font-family: ${({ theme }) => theme.FONT.STYLE.PROMPT_MEDIUM};
          }
        }
        .reward_img {
          margin: auto;
          width: 50%;
          height: auto;
        }
        .reward_img_smooth {
          margin: auto;
          width: 160px;
          height: 160px;
        }
      }
    }
    .btn_back {
      margin: auto;
      width: 171px;
    }
  }
`;
